interface ColorsInterface {
  primary: string;
  darkprimary: string;

  lightpink: string;
  lightblack: string;

  black: string;
  mediumBlack: string;
  blue: string;

  darkgray: string;
  gray: string;
  lightgray: string;

  white: string;
  green: string;
  red: string;
  darkgreen: string;
  darkred: string;
}

const colors: ColorsInterface = {
  primary: '#eb0d45',
  darkprimary: '#99002e',

  lightpink: '#ffe3ed',

  lightblack: '#1a1a1a',

  black: '#000',
  mediumBlack: '#4D4D4D',
  blue: '#006e99',
  darkgray: '#6c6c6c',
  gray: '#b3b3b3',
  lightgray: '#f2f2f2',

  white: '#fff',
  green: '#e0f5de',
  red: '#ffebeb',
  darkgreen: '#3f9b35',
  darkred: '#c11e1e',
};

export default colors;
